import React from 'react';
import { Link } from 'react-router-dom';
import {
  LEGAL_EFFECTIVE_DATE,
  LEGAL_VERSION,
  PRIVACY_INTRO,
  PRIVACY_SECTIONS,
  TERMS_INTRO,
  TERMS_SECTIONS,
} from './legalContent';
import './legal.css';

interface LegalPageProps {
  kind: 'terms' | 'privacy';
}

// ponytail: linkify is scoped to our two contact strings, not a URL parser.
const renderLinked = (text: string): React.ReactNode =>
  text.split(/(info@pixle\.pro|pixle\.pro)/g).map((part, i) =>
    part === 'info@pixle.pro' ? (
      <a key={i} href="mailto:info@pixle.pro">
        {part}
      </a>
    ) : part === 'pixle.pro' ? (
      <a key={i} href="https://pixle.pro" target="_blank" rel="noreferrer">
        {part}
      </a>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    )
  );

const LegalPage: React.FC<LegalPageProps> = ({ kind }) => {
  const isTerms = kind === 'terms';
  const sections = isTerms ? TERMS_SECTIONS : PRIVACY_SECTIONS;

  return (
    <main className="legal-container">
      <div className="legal-card">
        <Link to="/login" className="legal-back">
          ← Back to login
        </Link>
        <h1>{isTerms ? 'Pixle Terms of Service' : 'Pixle Privacy Policy'}</h1>
        <p className="legal-meta">
          Last Updated: {LEGAL_EFFECTIVE_DATE} · v{LEGAL_VERSION}
        </p>
        {isTerms
          ? TERMS_INTRO.map((paragraph) => (
              <p key={paragraph.slice(0, 32)}>{renderLinked(paragraph)}</p>
            ))
          : PRIVACY_INTRO.map((paragraph) => (
              <p key={paragraph.slice(0, 32)}>{renderLinked(paragraph)}</p>
            ))}
        {sections.map((section) => (
          <section key={section.heading}>
            <h2>{section.heading}</h2>
            {section.body.map((paragraph) => (
              <p key={paragraph.slice(0, 32)}>{renderLinked(paragraph)}</p>
            ))}
          </section>
        ))}
        <p className="legal-meta">
          {isTerms ? (
            <>
              Also see our <Link to="/privacy">Privacy Policy</Link>.
            </>
          ) : (
            <>
              Also see our <Link to="/terms">Terms of Service</Link>.
            </>
          )}
        </p>
      </div>
    </main>
  );
};

export default LegalPage;
